import { useEffect, useState } from 'react';
import { useFlutterwave } from 'flutterwave-react-v3';
import { PUBLIC_KEY } from '../../utils/EditorToolbar';

import { saveOrders, updateOrder } from '../../services/paymentService';

const Payment = () => {
  const [reference, setReference] = useState('');
  const [loading, setLoading] = useState(false);

  let sCart = JSON.parse(localStorage.getItem('cart'));
  let values = JSON.parse(localStorage.getItem('userData'));
  let token = localStorage.getItem('token');
  let courseids = sCart ? sCart?.map((el) => Number(el.id)) : [];

  let productPrice = sCart ? sCart?.map((el) => Number(el.price)) : [];

  let totalProductPrice =
    productPrice.length > 0 ? productPrice.reduce((a, b) => a + b, 0) : 0;

  const config = {
    public_key: PUBLIC_KEY,
    tx_ref: reference,
    amount: totalProductPrice,
    currency: 'NGN',
    payment_options: 'card,mobilemoney,ussd',
    customer: {
      email: values?.email || '',
      phone_number: '',
      name: `${values?.firstName} ${values?.lastName}` || '',
    },
    customizations: {
      title: 'Personalized Learning by Edves',
      description: 'Payment for items in cart',
      logo: 'https://st2.depositphotos.com/4403291/7418/v/450/depositphotos_74189661-stock-illustration-online-shop-log.jpg',
    },
  };

  const handleFlutterPayment = useFlutterwave(config);
  useEffect(() => {
    setReference(`PL-EDV${Date.now()}${Math.floor(Math.random() * 10 + 1)}`);
    const pay = async () => {
      let orderData = {
        courses: courseids,
        paymentGateway: 1,
        reference: reference,
      };
      let response = await saveOrders(values.id, orderData, token);

      handleFlutterPayment({
        callback: async (response) => {
          console.log(response);
          let token = localStorage.getItem('token');

          let verifyResponse = await updateOrder(
            values.id,
            {
              paymentGatewayReference: response.transaction_id,
            },
            token,
            response.tx_ref
          );
        },
        onClose: () => {
          setLoading(false);
          localStorage.removeItem('cart');
        },
      });
    };
    pay();
  }, []);

  return <div>Payment</div>;
};

export default Payment;
